// Report type constants
export const REPORT_TYPES = {
    INCORRECT_CONTENT: 'Incorrect Content/Media',
    ADD_ARTIST_TO_ORG: 'Add Artist To My Label',
    MISSING_CONTENT: 'Missing Content',
    DISASSOCIATE_CONTENT: 'Disassociate Content',
    OTHER: 'Other'
  }

  // Export as an array for dropdown options
  export const REPORT_TYPE_OPTIONS = Object.values(REPORT_TYPES)

  // Mapping between report types and query parameter values
  export const REPORT_TYPE_TO_QUERY = {
    [REPORT_TYPES.INCORRECT_CONTENT]: 'incorrect-content-or-media',
    [REPORT_TYPES.ADD_ARTIST_TO_ORG]: 'add-artist-to-my-label',
    [REPORT_TYPES.MISSING_CONTENT]: 'missing-content',
    [REPORT_TYPES.DISASSOCIATE_CONTENT]: 'disassociate-content',
    [REPORT_TYPES.OTHER]: 'other'
  }

  // Reverse mapping for query parameter to report type
  export const QUERY_TO_REPORT_TYPE = Object.fromEntries(
    Object.entries(REPORT_TYPE_TO_QUERY).map(([key, value]) => [value, key])
  )